// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3VuD5","inputWrap":"styles_inputWrap__37UF0","input":"styles_input__1v-RN"};